import { HelpdeskHeader } from "./Header";
import HelpdeskSearch from "./Search";

export { HelpdeskHeader, HelpdeskSearch };



// WEBPACK FOOTER //
// ./src/components/Helpdesk/Header/index.js